export const DEFAULT_PRACTICE_ID = 'DEFAULT_PRACTICE_ID';
export const DEFAULT_DIARY_ID = 'DEFAULT_DIARY_ID';
export const DEFAULT_CLINICIAN_ID = 'DEFAULT_CLINICIAN_ID';
